export default {

  new() {
    document.addEventListener('DOMContentLoaded', () => {
      Array.from(document.getElementsByClassName('modal-load-submit')).forEach(el => {
        el.addEventListener('click', (e) => {
          const spinner = document.createElement('div')
          spinner.className = 'loader'

          const modal = document.createElement('div')
          modal.className = 'modal-on'
          modal.appendChild(spinner)

          document.body.appendChild(modal)
        })
      })
    })
  }
}